import { routers } from '@/helper/routers';

export default[
    {
        path: routers.THANKS_PAGE,
        name: 'thanks-page',
        component: () => import('@/views/thanks-page/Index')
    },
]